'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _reactRouter = require('react-router');

var _pathNormalize = require('path-normalize');

var _pathNormalize2 = _interopRequireDefault(_pathNormalize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var handleTraversal = function handleTraversal(path) {
  return path.split('/').filter(function (s) {
    return !/^\.{2,}$/.test(s);
  }).join('/');
};

var Normalize = function Normalize(_ref) {
  var _ref$location$pathnam = _ref.location.pathname,
      pathname = _ref$location$pathnam === undefined ? '' : _ref$location$pathnam,
      children = _ref.children;

  var normalized = (0, _pathNormalize2.default)(handleTraversal(pathname));
  return normalized === pathname ? children : React.createElement(_reactRouter.Redirect, { to: normalized });
};

exports.default = (0, _reactRouter.withRouter)(Normalize);
module.exports = exports['default'];



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-router-path-normalize/lib/index.js
// module id = 199
// module chunks = 0